export default __webpack_public_path__ + "static/media/logobsc.dcb65397.png";